import React from "react"
import { ViewStyle, Dimensions } from "~/ui/primitives"
import { useTheme } from "~/ui/styled"
import { StartFlex, Text, IconFont } from "~components/El"

interface NoDataProps {
  title?: string | React.ReactNode
  content?: string | React.ReactNode
  style?: ViewStyle
}
const NoData: React.FC<NoDataProps> = ({
    title = "未找到用户",
    content = "请检查手机号/邮箱/ID是否正确",
    style = {}
}) => {
  const theme = useTheme()
  const { height } = Dimensions.get("window")
  return (
    <StartFlex flexDirection="column" mt={Math.floor(height / 6)} style={style}>
       <IconFont name="ss" size={40} color={theme.colors.infoText} />
       <Text fontSize={theme.fontSizes.lg} color={theme.colors.text} fontWeight="600" mt="20px">{title}</Text>
       <Text fontSize={theme.fontSizes.md} color={theme.colors.infoText} mt="10px">{content}</Text>
    </StartFlex>
  )
}

export default React.memo(NoData)
